import { observable } from 'mobx';
import Client from '../../common/client';
import moment from 'moment';

const CallServiceSearchStore = observable({
  callServiceSearch: null,

  *getCusEntReceiptListSearch(fromDate, toDate) {
    try {
      const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

      if (!fromDate) {
        // fromDate = moment().add(-1, 'months').format('YYYYMMDD');
        fromDate = moment().format('YYYYMMDD');
      }

      if (!toDate) {
        // toDate = moment().add(-1, 'days').format('YYYYMMDD');
        toDate = moment().format('YYYYMMDD');
      }

      let response = yield Client.post('/Cems/CustomerEntertainment/CusEntReceiptListSearch/', {
        entCode: code,
        fromDate: fromDate,
        toDate: toDate,
      });

      const callServiceSearch = response.data;

      if (callServiceSearch) {
        this.callServiceSearch = callServiceSearch;
      }
    } catch (error) {
      console.log(`CallServiceSearchListStore > *getCusEntReceiptListSearch : ${error.message}`);
    }
  },

  clear() {
    this.callServiceSearch = null;
  },
});

export default CallServiceSearchStore;
